'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  align-items: center;\n  color: ', ';\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  height: ', ';\n  line-height: normal;\n  position: relative;\n  top: ', ';\n  width: ', ';\n  z-index: ', ';\n\n  &::after {\n    ', ';\n    background: ', ';\n    border-radius: 100%;\n    content: \' \';\n    left: 50%;\n    padding: ', ';\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &[aria-disabled=\'true\'] {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n'], ['\n  ', ';\n  align-items: center;\n  color: ', ';\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  height: ', ';\n  line-height: normal;\n  position: relative;\n  top: ', ';\n  width: ', ';\n  z-index: ', ';\n\n  &::after {\n    ', ';\n    background: ', ';\n    border-radius: 100%;\n    content: \' \';\n    left: 50%;\n    padding: ', ';\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &[aria-disabled=\'true\'] {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _renderProp = require('../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _iconName = require('../utils/propTypes/iconName');

var _Color = require('../core/Color');

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _Style = require('../core/Style');

var _Styles = require('../utils/Styles');

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UIIconHolder = require('../icon/UIIconHolder');

var _UIIconHolder2 = _interopRequireDefault(_UIIconHolder);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DialogButton = (0, _styledComponents2.default)(function (props) {
  var __hovered = props.hovered,
      rest = _objectWithoutProperties(props, ['hovered']);

  return _react2.default.createElement(_UIClickable2.default, rest);
}).attrs({ className: 'private-modal__control' }).withConfig({
  displayName: 'UIDialogButton__DialogButton'
})(_templateObject, (0, _Styles.setUiTransition)('color'), _colors.OLAF, (0, _Style.remCalc)(_sizes.MODAL_CLOSE_BUTTON_SIZE), (0, _Style.remCalc)(_sizes.MODAL_CLOSE_BUTTON_OFFSET), (0, _Style.remCalc)(_sizes.MODAL_CLOSE_BUTTON_SIZE), _sizes.MERCURY_LAYER, (0, _Styles.setUiTransition)('background'), function (props) {
  return props.hovered && (0, _Color.rgba)(_colors.OLAF, 0.1);
}, (0, _Style.remCalc)(20));

// fix for IE11 misaligning icons when using UIIconHolder:
// https://git.hubteam.com/HubSpot/UIComponents/issues/5105
var ICON_STYLES = {
  marginLeft: 'auto',
  marginRight: 'auto'
};

var UIDialogButton = _react2.default.createClass({
  displayName: 'UIDialogButton',

  propTypes: {
    'aria-label': _react.PropTypes.string.isRequired,
    hovered: _react.PropTypes.bool,
    IconHolder: RenderProp.getPropType(_UIIconHolder2.default),
    iconName: (0, _iconName.getIconNamePropType)()
  },

  getDefaultProps: function getDefaultProps() {
    return {
      IconHolder: _UIIconHolder2.default
    };
  },
  render: function render() {
    var _props = this.props,
        hovered = _props.hovered,
        IconHolder = _props.IconHolder,
        iconName = _props.iconName,
        rest = _objectWithoutProperties(_props, ['hovered', 'IconHolder', 'iconName']);

    return _react2.default.createElement(
      DialogButton,
      _extends({}, rest, { hovered: hovered }),
      _react2.default.createElement(IconHolder, {
        innerStyles: ICON_STYLES,
        name: iconName,
        padding: 0,
        size: 'xxs'
      })
    );
  }
});

exports.default = (0, _Hoverable2.default)(UIDialogButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/dialog/UIDialogButton.js
// module id = 291
// module chunks = 0